import { CmsImageURL } from 'common/utils/constants/cms.constants';

export const strapiImageLoader = ({ src }: { src: string }): string => {
  return `${CmsImageURL}${src}`;
};
